module.exports = __webpack_public_path__ + "static/julia-b6b42d4b62f56d887ea1790ea0c4d3e9.pdf";